import { IonCol, IonContent, IonGrid, IonHeader, IonPage, IonRouterLink, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
import ExploreContainer from '../components/ExploreContainer';
import Header from '../components/Header';
import TopRightFab from '../components/TopRightFab';
import './Home.css';

const Home: React.FC = () => {
  return (
    <IonPage>
      <Header/>
      <TopRightFab/>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Blankk</IonTitle>
            
          </IonToolbar>
        </IonHeader>
        <ExploreContainer />
      </IonContent>
    </IonPage>
  );
};

export default Home;
